import React from 'react';
import styled from '@emotion/styled';
import { colors, device } from './layout/GlobalStyles';
import { StaticImage } from 'gatsby-plugin-image';
import { Button } from './layout/StyledComponents';
import rectangle from '../images/svgs/mask-slant.svg';
import girl from '../images/homepage.jpg';
import { css, cx } from '@emotion/css';

const StyledYellowPanel = styled.div<Props>`
    display: flex;

    background: ${colors.white};
    width: 90.5vw;
    margin: 2em auto;
    border-radius: 20px;
    .title {
        box-shadow: none;
        text-align: center;
        margin: 1em auto 0em;
    }
    h4 {
        font-size: 32px;
    }
    .text-container {
        padding: 0em 1.25em;
    }
    .image-container {
        display: flex;
        margin: 0 auto;
        flex-direction: column;
        align-items: center;
        min-width: 300px;
        position: relative;
        img {
            padding: 4em 0em 0em;
        }
        .gold-panel {
            position: absolute;
            top: 4em;
            width: 72px;
            z-index: 20;
            left: 9em;
        }
    }

    @media ${device.tablet} {
        max-width: 750px;
        padding: 1em 2em 4em;
        margin: 2em auto 0em;
        .image-container {
            margin: 0 auto;
            min-width: 300px;
            .gold-panel {
                display: none;
                position: absolute;
                top: 2em;
                left: 14em;
                width: 253px;
            }
            position: relative;
        }
        h3 {
            padding-right: 1em;
        }
        .text-container {
            display: flex;
            flex-direction: column;
            padding: ${({ reverse }) => (reverse ? '10em 0em 6em 3em' : '10em 6em 0em 3em')};
        }
        .flex-container {
            display: flex;
            flex-direction: ${({ reverse }) => (reverse ? 'row' : 'row-reverse')};
        }
    }
    @media ${device.laptop} {
        max-width: 1050px;
        margin-top: 4em;
    }
`;

interface Props {
    reverse?: boolean;
}

export const YellowPanel: React.FC<Props> = ({ children, reverse }) => {
    return (
        <StyledYellowPanel className="shadow" reverse={reverse}>
            {children}
        </StyledYellowPanel>
    );
};
